import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** PACE（完璧弾丸トラベラー） */
const paceContent: DiagnosisResultContent = {
  code: 'PACE',
  name: '完璧弾丸トラベラー',
  catchphrase: '効率こそ正義！行程を秒単位で組む完璧弾丸トラベラー',
  rarity: 3,
  style:
    '「限られた時間で最大の成果」を追求する計画型の疾走族。事前に移動・予約・順路を綿密に組み、ムダな待ち時間を徹底排除する。定番も新体験も効率よく回り、旅の密度を極限まで高める。軍事作戦レベルの段取り力で、同行者を「こんなに回れるの!?」と驚かせる、旅のエースパイロットタイプ。',
  strengths: [
    { lead: '段取りの精度が高い', text: '移動・予約・順路を綿密に設計し、ロスなく濃い旅を実現できる。' },
    { lead: '回る量が圧倒的', text: '短い滞在でも見どころと体験を効率よく詰め込める。' },
    { lead: 'トラブルに強い', text: '事前準備が厚く、想定外にも比較的冷静に対応できる。' },
  ],
  weaknesses: [
    { lead: '余白がない', text: '詰め込みすぎて、ふらりと寄り道する楽しさを逃しがち。' },
    { lead: '柔軟性に欠ける', text: '計画が崩れるとイライラし、同行者を疲れさせることも。' },
    { lead: '「旅」より「達成」', text: 'チェックリスト消化に集中し、ゆったり味わう余裕が少ない。' },
  ],
  aaru: [
    { icon: 'coffee', text: '分刻みのしおりを作成' },
    { icon: 'msg', text: '「次◯時集合ね」が口癖' },
    { icon: 'camera', text: 'Google Mapに行程を秒単位登録' },
    { icon: 'coffee', text: '待ち時間が発生すると焦る' },
  ],
  manual: {
    good: '時間を守る／計画への協力を惜しまない',
    ng: '「とりあえず現地で決めよう」と丸投げする',
    tips: '1日1枠だけ「自由時間」を入れると衝突が減る',
  },
  compatibility: {
    good: 'PACZ（安心計画）／PRCE（バランス）',
    conflict: 'SRCZ（マイペース）／SACZ（脱力系）',
    tips: '集合時間だけ厳守、道中はゆるめにすると噛み合う',
  },
  destinations: {
    domestic: '東京（効率よく定番網羅）／大阪（食と観光を短時間制覇）',
    overseas: 'シンガポール（コンパクトに回れる）／韓国（移動が速い）',
  },
};

export const paceDiagnosisResult = buildDiagnosisResult(paceContent);
